import Icon from 'components/Icon';
import {Typography} from 'components/Typography';
import {FC, useMemo} from 'react';
import style from './style.module.scss';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectProductData} from 'modules/product-card/selectors';
import {SECTION_CODE} from 'modules/product-card/constants';
import {getProductCentralStoresWithStock} from 'modules/wineshops-list/helpers';

export const ProductReceivingMethodTomorrow: FC = () => {
    const productData = useAppSelector(selectProductData);

    const text = useMemo(() => {
        if (productData?.topSection === SECTION_CODE.VODA_I_SOKI) {
            return 'Доставка с завтрашнего дня домой или в офис';
        }
        if (
            1 < (productData?.stocksByCity.stores.length ?? 0) ||
            0 < getProductCentralStoresWithStock(productData).length
        ) {
            return 'Самовывоз с завтрашнего дня из любой винотеки';
        }

        return 'Самовывоз с завтрашнего дня из винотеки';
    }, [productData]);

    return (
        <div className={style.main} data-skeleton-item={true}>
            <Icon className={style.icon} icon={'placemark-fill'} />
            <Typography variant={'label-14-r'}>{text}</Typography>
        </div>
    );
};
